import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Box } from 'reflexbox'

import ProgressBar from 'components/fulcrum/progressBar/FulcrumCircularProgressBar'
import UploadIconContainer from './UploadIconContainer'

import styles from './styles.scss'

const UploadProgress = props => {
  return (
    <UploadIconContainer>
      <div styleName='uploadText'>
        <span>Uploading ...</span>
      </div>
      <Box auto/>
      <div styleName='progressContainer'>
        <ProgressBar/>
      </div>
    </UploadIconContainer>
  )
}
const withStyle = CSSModules(styles)
export default withStyle(UploadProgress)
